(function () {

    function getSelectedVariantId() {

        const input = document.querySelector('input[name="id"]');

        return input ? input.value : null;

    }

    function filterGallery() {

        const variantId = getSelectedVariantId();

        if (!variantId) return;

        const slides = document.querySelectorAll(
            'slideshow-slide[data-variant-group]'
        );

        slides.forEach(slide => {

            const show = slide.dataset.variantGroup === variantId;

            slide.toggleAttribute('hidden', !show);

            slide.setAttribute(
                'aria-hidden',
                show ? 'false' : 'true'
            );

        });

    }

    document.addEventListener("change", function(e){

        if(
            e.target.matches('input[name="id"]') ||
            e.target.matches('select[name="id"]')
        ){

            requestAnimationFrame(filterGallery);

        }

    });

    document.addEventListener("variant:change",filterGallery);

    document.addEventListener("product:variant-change",filterGallery);

    document.addEventListener("DOMContentLoaded",filterGallery);

})();